var React = require('react');

function IconCheckboxOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 5.667v18.666H5.667V5.667h18.666m0-2.667H5.667A2.675 2.675 0 0 0 3 5.667v18.666A2.675 2.675 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V5.667A2.675 2.675 0 0 0 24.333 3z","transform":"translate(-3 -3)"}));
}

IconCheckboxOff.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconCheckboxOff;

IconCheckboxOff.default = IconCheckboxOff;
